import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import { imageUrl } from '../Shared/imageUrl';

export const VideoWrapper = createComponent('div', {
  className: cx(
    'overflow-hidden text-center',
    'relative top-20 sm:top-56',
    'min-h-[170px] w-4/5 min-w-[300px] sm:min-h-[360px] sm:w-2/3 sm:min-w-[320px]',
    'mx-auto pt-[56.25%] sm:pt-[35.25%]'
  )
});

export const VideoIframe = createComponent<Partial<HTMLIFrameElement>>(
  'iframe',
  { className: 'absolute left-0 top-0 h-full w-full border-0 sm:h-[93%]' }
);

export const HeroImageContent = createComponent('div', {
  className: 'mb-56 w-full text-center text-white sm:mb-72'
});

export const HeroImage = createComponent('div', {
  className: cx(
    'p-12',
    'bg-[length:100%_80%] bg-no-repeat md:bg-[length:100%_75%]',
    '[background-image:var(--mobile-image)] sm:[background-image:var(--tablet-image)] md:[background-image:var(--desktop-image)]'
  ),
  style: {
    '--desktop-image': `url(${imageUrl('hero-desktop.jpg', {
      format: 'auto',
      optimize: 'medium'
    })})`,
    '--mobile-image': `url(${imageUrl('hero-mobile.jpg', {
      format: 'auto',
      optimize: 'medium'
    })})`,
    '--tablet-image': `url(${imageUrl('hero-tablet.jpg', {
      format: 'auto',
      optimize: 'medium'
    })})`
  }
});

export const ZipCodeInputWrapper = createComponent('div', {
  className: 'mx-auto mt-20 w-[300px] md:mt-48'
});
